// This is the main entry point for webpack.
// It should include the main resources to be webpack-ed, specific to this application.

const ListUI = require('./js/list-ui.js')

module.exports = exports = {
   // Modules to expose to the application pages
   ListUI
}
